import { useBlockProps } from "@wordpress/block-editor";
import { FC } from 'react';


const Save: FC = () => {
    return (
        <a {...useBlockProps.save()} aria-label="Nach oben scrollen" href="#"><i className="fa-solid fa-arrow-up"></i></a>
    );
};

export default Save;
